export default __webpack_public_path__ + "static/media/instant-val-left-img.b98dba71.png";